function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, Fragment, useMemo } from "react";
import InfiniteList from "@researchgate/react-intersection-list";
import update from "immutability-helper";
import { useParams } from "react-router-dom";
import { Text } from "sprout-ui-primitives";
import { useProfilePageFollowingTopicsQuery } from "sprout-graphql";
import { Glitch, NotFound } from "@sprout/views";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import Head from "@sprout/client-layout/dist/Head";
import { Topic } from "@sprout/client-components/dist/Topic";
import { useNavigationList, useNavigationListItem } from "@sprout/list-navigation";
import { CardsWrapper } from "@sprout/client-components/dist/Cards";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
const SUPPORTED_ACTIONS = [
    "OPEN"
];
const ProfilePageFollowingTopicsTopic = (props)=>{
    const { topic  } = props;
    const { helpers: navigationItemHelpers , navProps  } = useNavigationListItem(String(topic.id), useMemo(()=>({
            object: topic
        }), [
        topic
    ]));
    return /*#__PURE__*/ _jsx(Topic, _objectSpread({
        topic: topic,
        navigationItemHelpers: navigationItemHelpers
    }, navProps));
};
const ProfilePageFollowingTopicsList = (props)=>{
    const { awaitMore , topics , loadMore  } = props;
    const { navProps , Provider  } = useNavigationList("ProfilePageFollowingTopics", useMemo(()=>({
            actions: SUPPORTED_ACTIONS
        }), []));
    const renderItem = useCallback((index)=>{
        const followingTopic = (topics || [])[index];
        const { nodeId , topic  } = followingTopic;
        if (topic) return /*#__PURE__*/ _jsx(ProfilePageFollowingTopicsTopic, {
            topic: topic
        }, nodeId);
        // TODO: hack to please TS
        return /*#__PURE__*/ _jsx(Fragment, {}, nodeId);
    }, [
        topics
    ]);
    const itemsRenderer = useCallback((items, ref)=>{
        return /*#__PURE__*/ _jsx(CardsWrapper, {
            ref: (element)=>{
                if (element) {
                    navProps.ref.current = element;
                    ref(element);
                }
            },
            children: items
        });
    }, [
        navProps.ref
    ]);
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(InfiniteList, {
            awaitMore: awaitMore,
            renderItem: renderItem,
            itemsRenderer: itemsRenderer,
            itemCount: topics.length,
            onIntersection: loadMore,
            pageSize: topics.length,
            threshold: "25%"
        })
    });
};
const ProfilePageFollowingTopics = (props)=>{
    const { fullName  } = props;
    const { username  } = useParams();
    const { loading , data , error , fetchMore  } = useProfilePageFollowingTopicsQuery({
        fetchPolicy: "cache-and-network",
        variables: {
            username
        }
    });
    const currentUser = useCurrentUser();
    const showSnackbar = useSnackbar();
    const user = data === null || data === void 0 ? void 0 : data.user;
    const followingTopics = user === null || user === void 0 ? void 0 : user.followingTopics.nodes;
    const pageInfo = user === null || user === void 0 ? void 0 : user.followingTopics.pageInfo;
    const { endCursor =null , hasNextPage =false  } = pageInfo || {};
    const loadMore = useCallback(()=>{
        fetchMore({
            variables: {
                username,
                endCursor
            },
            updateQuery (prevResult, { fetchMoreResult  }) {
                var ref, ref1;
                const fetchMoreResultFollowingTopics = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (ref = fetchMoreResult.user) === null || ref === void 0 ? void 0 : ref.followingTopics.nodes;
                const fetchMoreResultPageInfo = fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (ref1 = fetchMoreResult.user) === null || ref1 === void 0 ? void 0 : ref1.followingTopics.pageInfo;
                if (fetchMoreResultFollowingTopics && fetchMoreResultPageInfo) return update(prevResult, {
                    user: {
                        followingTopics: {
                            nodes: {
                                $push: fetchMoreResultFollowingTopics
                            },
                            pageInfo: {
                                $set: fetchMoreResultPageInfo
                            }
                        }
                    }
                });
                return prevResult;
            }
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        endCursor,
        fetchMore,
        showSnackbar,
        username
    ]);
    if (loading && !data) return null;
    // only show error on initial query
    if (error && !data) return /*#__PURE__*/ _jsx(Glitch, {
        error: error
    });
    /**
   * In theory, if there's no `user`, there's no `followingTopics`
   * but need to be explicit for TS
   */ if (!user || !followingTopics) return /*#__PURE__*/ _jsx(NotFound, {});
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                title: user.nodeId !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.nodeId) ? "Trees followed by you | Sprout" : `Trees followed by ${fullName ? `${fullName} (${username})` : username} | Sprout`
            }),
            followingTopics.length === 0 ? /*#__PURE__*/ _jsx(Text, {
                color: "black.60",
                align: "center",
                my: "48px",
                children: "No trees followed yet"
            }) : /*#__PURE__*/ _jsx(ProfilePageFollowingTopicsList, {
                awaitMore: loading ? false : hasNextPage,
                topics: followingTopics,
                loadMore: loadMore
            })
        ]
    });
};
export default ProfilePageFollowingTopics;
